//偏好地区
import React, { useState, useMemo } from 'react';
import { Cascader, message } from 'antd';
import { ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import styles from './PreferredRegions.module.scss';
import styles1 from './customCascader.module.scss';
import setRequiredFields from './GaokaoxkStore'
import optional2 from  './optional2.module.scss';
import { SVGPureIcon } from "@/ui";
import { observer } from 'mobx-react-lite';


// 原始选项数据（不包含计数）
const RAW_OPTIONS = [
    {
        value: '一线城市',
        label: '一线城市',
        children: [
            { value: '北京', label: '北京' },
            { value: '上海', label: '上海' },
            { value: '广州', label: '广州' },
            { value: '深圳', label: '深圳' }
        ]
    },
    {
        value: '新一线城市',
        label: '新一线城市',
        children: [
            { value: '成都', label: '成都' },
            { value: '杭州', label: '杭州' },
            { value: '重庆', label: '重庆' },
            { value: '西安', label: '西安' },
            { value: '苏州', label: '苏州' },
            { value: '武汉', label: '武汉' },
            { value: '南京', label: '南京' },
            { value: '天津', label: '天津' },
            { value: '郑州', label: '郑州' },
            { value: '长沙', label: '长沙' },
            { value: '东莞', label: '东莞' },
            { value: '佛山', label: '佛山' },
            { value: '宁波', label: '宁波' },
            { value: '青岛', label: '青岛' },
            { value: '沈阳', label: '沈阳' }
        ]
    },
    {
        value: '省份',
        label: '省份',
        children: [
            { value: '北京', label: '北京' },
            { value: '上海', label: '上海' },
            { value: '天津', label: '天津' },
            { value: '重庆', label: '重庆' },
            { value: '山东', label: '山东' },
            { value: '山西', label: '山西' },
            { value: '河南', label: '河南' },
            { value: '河北', label: '河北' },
            { value: '湖北', label: '湖北' },
            { value: '湖南', label: '湖南' },
            { value: '江西', label: '江西' },
            { value: '辽宁', label: '辽宁' },
            { value: '吉林', label: '吉林' },
            { value: '黑龙江', label: '黑龙江' },
            { value: '江苏', label: '江苏' },
            { value: '浙江', label: '浙江' },
            { value: '安徽', label: '安徽' },
            { value: '福建', label: '福建' },
            { value: '广东', label: '广东' },
            { value: '广西', label: '广西' },
            { value: '四川', label: '四川' },
            { value: '陕西', label: '陕西' },
            { value: '甘肃', label: '甘肃' },
            { value: '海南', label: '海南' },
            { value: '贵州', label: '贵州' },
            { value: '内蒙古', label: '内蒙古' },
            { value: '云南', label: '云南' },
            { value: '青海', label: '青海' },
            { value: '宁夏', label: '宁夏' },
            { value: '新疆', label: '新疆' },
            { value: '西藏', label: '西藏' }
        ]
    }
];

const MAX_SELECTION = 10; // 最大选择数量为10

const PreferredRegions = () => {
    const [selectedValues, setSelectedValues] = useState([]);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [showWarning, setShowWarning] = useState(false);
    

    // 根据选中的值计算每个父级的选中数量
    const options = useMemo(() => {
        // 计算每个父级下选中的数量
        const parentCounts = {};
        setRequiredFields?.optionalFields?.preferredRegions1.forEach(path => {
            const parentValue = path[0];
            parentCounts[parentValue] = (parentCounts[parentValue] || 0) + 1;
        });

        // 创建带计数的选项
        return RAW_OPTIONS.map(parent => {
            const totalChildren = parent.children.length;
            const selectedCount = parentCounts[parent.value] || 0;

            return {
                ...parent,
                label: `${parent.label} (${selectedCount}/${totalChildren})`,
                children: parent.children.map(child => ({ ...child }))
            };
        });
    }, [setRequiredFields?.optionalFields?.preferredRegions1]);
    // 数据转换与去重
    function transformAndDeduplicate(data) {
        // 1. 扁平化为一维数组
        const flattened = data.reduce((acc, item) => acc.concat(item), []);

        // 2. 去重处理（保留顺序）
        const deduplicated = [];
        const seen = new Set();

        for (const item of flattened) {
            if (!seen.has(item)) {
                seen.add(item);
                deduplicated.push(item);
            }
        }

        return deduplicated;
    }

    const onChange = (value) => {
        // 检查是否超过最大选择数
        if (value.length > MAX_SELECTION) {
            setShowWarning(true);
            setTimeout(() => setShowWarning(false), 2000);
            message.warning(`最多只能选择${MAX_SELECTION}个科目`);
            return;
        }

        const result = transformAndDeduplicate(value);

        // 更新选择值
        setSelectedValues(value);
        setShowWarning(false);

        // 使用 setOptionalFields 更新状态
        setRequiredFields.setOptionalFields({
            preferredRegions: result, // 更新 classification 属性
        });
        setRequiredFields.setOptionalFields({
            preferredRegions1: value
        });

        // 如果选择了最大数量，关闭下拉框
        if (value.length === MAX_SELECTION) {
            setDropdownVisible(false);
        }
    };

    const handleDropdownVisibleChange = (visible) => {
        setDropdownVisible(visible);
    };

    const dropdownRender = (menus) => (
        // 使用模块化类名
        <div className={styles.customDropdownContainer}>
            <div className={`${styles.selectionHint} ${selectedValues.length === MAX_SELECTION ? styles.completed : ''}`} style={{
                padding: '10px 0 0 10px', fontSize: '12px',
                color: '#00000080'
            }}>
                {`最多只能选${MAX_SELECTION}个`}
                {/* {`（ ${selectedValues.length}/${MAX_SELECTION}）`} */}
            </div>

            {menus}
        </div>
    );


    const tagRender = (props) => {
        const { label, closable, onClose } = props;

        const handleClose = (e) => {
            e.preventDefault();
            e.stopPropagation();
        };
        const preferredRegionsList = setRequiredFields.optionalFields.preferredRegions?.flat()

        return (
            <span className={styles.customTag} style={{ color: '#006AFF', fontWeight: 700 }}>
                {label}
                {closable && preferredRegionsList?.length > 1 && preferredRegionsList?.indexOf(label) !== preferredRegionsList?.length - 1 && (
                    <span className={styles.tagCloseIcon} onClick={handleClose}>
                        、
                    </span>
                )}
            </span>
        );
    };

    // 自定义字段名：使用路径作为值
    const fieldNames = {
        children: 'children',
        label: 'label',
        value: 'value'
    };

    return (
        <div>
            <Cascader
                className={styles1['custom-cascader']}
                popupClassName={optional2['custom-cascader-dropdown']}
                style={{
                    width: 'auto', // 关键：设置为 auto
                    minWidth: 76, // 保留最小宽度
                    display: 'inline-block' // 确保宽度自适应
                }}
                multiple
                allowClear={false}
                placeholder="地区"
                options={options}
                value={setRequiredFields?.optionalFields?.preferredRegions1}
                onChange={onChange}
                open={dropdownVisible}
                onDropdownVisibleChange={handleDropdownVisibleChange}
                dropdownRender={dropdownRender}
                tagRender={tagRender}
                maxTagCount={3}
                fieldNames={fieldNames}
                showCheckedStrategy={Cascader.SHOW_CHILD} // 只显示子节点
                maxTagPlaceholder={(omittedValues) => (
                    <span style={{ color: '#006AFF' }}>
                        ...
                    </span>
                )}
                // 自定义选择器右侧的下拉箭头
                suffixIcon={
                    <SVGPureIcon
                        name={dropdownVisible ? "shangjant" : "ArrowDown"}
                        className=''
                        style={{ width: 16, height: 16 }}
                    />
                }

                // 自定义下拉菜单中的展开箭头
                expandIcon={
                    (
                        <SVGPureIcon
                            name="ArrowRight"
                            className='text-black text-opacity-50'
                            style={{
                                width: 16,
                                height: 16,
                            }}
                        />
                    )
                }
                optionRender={(option, state = {}) => {
                    const huoquxuanz = setRequiredFields?.optionalFields?.preferredRegions?.flat(Infinity)

                    return (
                        <div style={{ color: huoquxuanz?.includes(option?.label) ? "#006AFF" : '' }}>
                            {option?.label}
                        </div>
                    );
                }}

            />
        </div>
    );
};

export default observer(PreferredRegions);